import "./App.css";
import Header from "./Components/Header/Header";
import Content from "./Components/Content/Content";
import video from "../src/Videos/steambackground.mp4";

function App() {
  return (
    <>
      <video
        loop
        playsInline
        autoPlay
        muted
        className="App-Background"
        src={video}
      />
      <div className="App MidnightTheme">
        <Header />
        <Content />
      </div>
    </>
  );
}

export default App;
